import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as SorryBuddy } from '../../../../../assets/icons/buddy-sorry.svg';
import { BreadcrumbItemProps } from '../../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import GenericPageNE from '../../../../../shared/components/GenericPageNE/GenericPageNE';
import { TRANSLATION_POINTS_BY_FILE } from '../../../../../shared/translations/rewards';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';

interface PointsByFileErrorProps {
  breadcrumbs: BreadcrumbItemProps[];
  retry: GenericVoidFunction;
  resetPage: GenericVoidFunction;
  loading: boolean;
}

const PointsByFileError = ({ breadcrumbs, retry, resetPage, loading }: PointsByFileErrorProps) => {
  const { t } = useTranslation();

  return (
    <GenericPageNE
      breadcrumbs={breadcrumbs}
      ImageComponent={SorryBuddy}
      title={t(TRANSLATION_POINTS_BY_FILE.error.title)}
      description={t(TRANSLATION_POINTS_BY_FILE.error.description)}
      loading={loading}
      primaryButton={{
        text: t(TRANSLATION_POINTS_BY_FILE.error.retry),
        action: retry
      }}
      secondaryButton={{
        text: t(TRANSLATION_POINTS_BY_FILE.error.cancel),
        action: resetPage
      }}
    />
  );
};

export default PointsByFileError;
